var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy, OnInit } from '@angular/core';
import { SideMenuService } from '../../core/side-bar/side-menu/side-menu.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AssignmentsService } from '../../core/models/assignment/assignments.service';
import { Assignment } from '../../core/models/assignment/assignment';
import { switchMap } from 'rxjs/operators';
import { NetStatusService } from '../../core/net-status/net-status.service';
import { DialogService } from '../../core/dialog/dialog.service';
import { ToasterService } from '../../core/toaster/toaster.service';
import { UserService } from '../../core/user/user.service';
import { IdbWrapperService } from '../../core/idb-wrapper/idb-wrapper.service';
import { AuditRefreshService } from '../audit/audit-refresh.service';
import { HttpHeaders } from '@angular/common/http';
import { UtilsService } from '../../core/utils/utils.service';
var AssignmentComponent = /** @class */ (function () {
    function AssignmentComponent(sideMenuService, router, activatedRoute, assignmentsService, netStatus, dialog, toaster, idbWrapper, userService, auditRefresh, utils) {
        this.sideMenuService = sideMenuService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.assignmentsService = assignmentsService;
        this.netStatus = netStatus;
        this.dialog = dialog;
        this.toaster = toaster;
        this.idbWrapper = idbWrapper;
        this.userService = userService;
        this.auditRefresh = auditRefresh;
        this.utils = utils;
    }
    AssignmentComponent.prototype.onEdit = function () {
        this.router.navigate(["assignments/" + this.id + "/edit"]);
    };
    AssignmentComponent.prototype.onDelete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var confirm;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dialog.confirmDialog('Confermi l\'eliminazione dell\'incarico?').toPromise()];
                    case 1:
                        confirm = _a.sent();
                        if (confirm) {
                            this.assignmentsService.deleteAssignment(this.assignment.id).subscribe(function () {
                                _this.toaster.displaySuccess('Incarico eliminato correttamente');
                                _this.router.navigate(['assignments']);
                            }, function (error) {
                                _this.toaster.displayError('Errore nell\'eliminazione dell\'incarico!');
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AssignmentComponent.prototype.onDownload = function (assignment) {
        this.assignmentsService.setAssignment(assignment);
    };
    AssignmentComponent.prototype.onReportDownload = function () {
        var _this = this;
        this.downloadingReport = true;
        this.assignmentsService.getAssignmentReport(this.assignment.id).subscribe(function (res) {
            var _a = _this.utils.blobAndFilenameFromRes(res), blob = _a.blob, filename = _a.filename;
            _this.utils.downloadFile(blob, filename);
            _this.downloadingReport = false;
        }, function () { return _this.downloadingReport = false; });
    };
    AssignmentComponent.prototype.onPictureReportDownload = function () {
        var _this = this;
        this.downloadingPicturesReport = true;
        this.assignmentsService.getPicturesReport(this.assignment.id).subscribe(function (res) {
            var _a = _this.utils.blobAndFilenameFromRes(res), blob = _a.blob, filename = _a.filename;
            _this.utils.downloadFile(blob, filename);
            _this.downloadingPicturesReport = false;
        }, function () { return _this.downloadingPicturesReport = false; });
    };
    AssignmentComponent.prototype.onPdfDownload = function () {
        var _this = this;
        this.downloadingPdf = true;
        this.assignmentsService.getFinalReport(this.assignment.id).subscribe(function (res) {
            var _a = _this.utils.blobAndFilenameFromRes(res), blob = _a.blob, filename = _a.filename;
            _this.utils.downloadFile(blob, filename);
            _this.downloadingPdf = false;
        }, function () { return _this.downloadingPdf = false; });
    };
    AssignmentComponent.prototype.onReportUpload = function (file) {
        var _this = this;
        this.uploadingPdf = true;
        var formData = new FormData();
        formData.append('final_report', file);
        this.assignmentsService.finalizeAssignment(this.assignment.id, formData, {
            headers: new HttpHeaders()
        }).subscribe(function (assignment) {
            _this.updateAssignment(new Assignment(assignment));
            _this.uploadingPdf = false;
        });
    };
    AssignmentComponent.prototype.updateAssignment = function (assignment) {
        this.sideMenuService.sideMenuState = { state: 'assignment', assignment: assignment };
        this.assignment = assignment;
    };
    AssignmentComponent.prototype.onUserEdit = function (resource) {
        return __awaiter(this, void 0, void 0, function () {
            var confirm;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dialog.choiceDialog({
                            title: "Selezione " + (resource === 'compiler' ? 'compilatore' : 'revisore'),
                            body: '',
                            placeholder: "Scegli un " + (resource === 'compiler' ? 'compilatore' : 'revisore'),
                            user: this.assignment.compiler
                        }).toPromise()];
                    case 1:
                        confirm = _a.sent();
                        if (!!confirm)
                            this.assignmentsService.updateUser(this.assignment.id, confirm.id, resource).subscribe(function (assignment) {
                                var user = _this.userService.user;
                                if (user.role === 'compiler' && assignment.compiler && assignment.compiler.id !== user.id && assignment.reviser && assignment.reviser.id !== user.id) {
                                    _this.router.navigate(['/']);
                                }
                                else {
                                    _this.updateAssignment(assignment);
                                }
                            });
                        return [2 /*return*/];
                }
            });
        });
    };
    AssignmentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.id = +this.activatedRoute.snapshot.params.id;
        this.idbWrapper.all('assignmentFields').subscribe(function (assignmentFields) {
            _this.assignmentFields = assignmentFields.reduce(function (obj, item) {
                var _a;
                return (__assign({}, obj, (_a = {}, _a[item['mnemonicLabel']] = item, _a)));
            }, {});
        });
        this.subscription = this.auditRefresh.auditRefresh$.pipe(switchMap(function () { return _this.netStatus.onlineStatus; }), switchMap(function (isOnline) { return _this.assignmentsService.getAssignment(isOnline, _this.id); })).subscribe(function (assignment) { return _this.updateAssignment(assignment); });
    };
    AssignmentComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return AssignmentComponent;
}());
export { AssignmentComponent };
